import { ListItem, ListItemText } from '@material-ui/core';
import match from 'autosuggest-highlight/match/index.js';
import parse from 'autosuggest-highlight/parse/index.js';
import React from 'react';
/**
 * Parses a full text based on a search term and returns the corresponding list of JSX.Elements
 * @param text The full text to be parsed
 * @param term The search term
 */

export const getMatchParts = (text, term) => {
  const matchValue = match(term, text);
  const parseValue = parse(term, matchValue);
  return parseValue.map((part, index) => part.highlight ? /*#__PURE__*/React.createElement("strong", {
    key: String(index)
  }, part.text) : /*#__PURE__*/React.createElement("span", {
    key: String(index)
  }, part.text));
};
/**
 * Default Suggsetion component for Reference Field
 * @param props
 */

export const ReferenceFieldSuggestion = props => {
  const primary = getMatchParts(props.query, props.item.DisplayName || props.item.Name);
  const secondary = getMatchParts(props.query, props.item.Path);
  return /*#__PURE__*/React.createElement(ListItem, {
    key: props.item.Id,
    button: true,
    selected: props.isHighlighted
  }, /*#__PURE__*/React.createElement(ListItemText, {
    "data-test": `suggestion-${(props.item.DisplayName || props.item.Name).replace(/\s+/g, '-').toLowerCase()}`,
    primary: primary,
    secondary: secondary
  }));
};
//# sourceMappingURL=ReferenceFieldSuggestion.js.map